// ----------------- Imports -----------------
import React from "react";

// ----------------- Component -----------------
const BrandingLayoutSkeleton = () => {
    return (
        <div className="layout lg:max-w-[1230px] mt-20 lg:mt-22 animate-pulse">
            {/* Hero Section */}
            <div className="relative w-full lg:aspect-[16/8] aspect-[11/16] rounded-[15px] overflow-hidden backdrop-blur-md">
                {/* Background image */}
                <div className="absolute top-0 left-0 w-full h-full bg-gray-300 dark:bg-gray-700" />

                {/* Overlay */}
                <div className="absolute inset-0 bg-[#00000031] rounded-[15px]" />

                {/* Content */}
                <div className="absolute inset-0 flex p-6 lg:p-[60px]">
                    <div className="flex flex-col w-1/2 gap-4">
                        {/* Logo circle */}
                        <div className="w-[125px] h-[125px] rounded-[15px] bg-gray-300 dark:bg-gray-700" />

                        {/* Title */}
                        <div className="h-[45px] w-[250px] rounded bg-gray-300 dark:bg-gray-700" />

                        {/* Description */}
                        <div className="flex flex-col gap-2 mt-4">
                            <div className="h-[18px] w-[90%] rounded bg-gray-300 dark:bg-gray-700" />
                            <div className="h-[18px] w-[85%] rounded bg-gray-300 dark:bg-gray-700" />
                            <div className="h-[18px] w-[80%] rounded bg-gray-300 dark:bg-gray-700" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Events Section */}
            <div className="mt-10">
                {/* Section title */}
                <div className="h-[30px] w-[180px] rounded bg-gray-300 dark:bg-gray-700 mb-6" />

                {/* Grid skeleton for events */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {[...Array(4)].map((_, i) => (
                        <div
                            key={i}
                            className="rounded-[15px] overflow-hidden border border-gray-200 dark:border-gray-800"
                        >
                            {/* Image placeholder */}
                            <div className="w-full h-[200px] bg-gray-300 dark:bg-gray-700" />

                            {/* Text placeholders */}
                            <div className="p-3 space-y-2">
                                <div className="h-[20px] w-[70%] rounded bg-gray-300 dark:bg-gray-700" />
                                <div className="h-[16px] w-[50%] rounded bg-gray-300 dark:bg-gray-700" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BrandingLayoutSkeleton;
